import React from 'react'
import '../../styles/Utils/Button.css'

function Button({ theme, icon, text, rounded, disabled, onClick }) {

    return (

        <div className='buttonContainer'>
            <div className={['button', rounded ? 'buttonRounded' : null, disabled ? 'buttonDisabled' : null, theme === 'dark' ? 'buttonDark' : theme === 'primary' ? 'buttonPrimary' : theme === 'danger' ? 'buttonDanger' : 'buttonLight'].join(" ")} onClick={() => onClick && !disabled ? onClick() : null}>
                <div className={['buttonIcon', theme === 'dark' ? 'buttonIconDark' : theme === 'primary' ? 'buttonIconPrimary' : theme === 'danger' ? 'buttonIconDanger' : 'buttonIconLight'].join(" ")}>
                    {icon}
                </div>
                <div className={['buttonText', theme === 'dark' ? 'buttonTextDark' : theme === 'primary' ? 'buttonTextPrimary' : theme === 'danger' ? 'buttonTextDanger' : 'buttonTextLight'].join(" ")}>{text}</div>
            </div>
        </div>

    )

}

export default Button